// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__9B0nP","sendOtp":"AuthorizeToLogin_sendOtp__2aSh7"};